import { useEffect, useState, type FormEvent } from 'react';
import { api, type User } from '../lib/api';

export function Login({ onLogin }: { onLogin: (u: User) => void }) {
  const [mode, setMode] = useState<'login' | 'register'>('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [allowRegistration, setAllowRegistration] = useState(false);

  useEffect(() => {
    api.authConfig().then((c) => setAllowRegistration(c.allow_registration), () => undefined);
  }, []);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onLogin(mode === 'login' ? await api.login(email, password) : await api.register(email, password));
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <form className="card login-card" onSubmit={submit}>
        <img className="login-logo" src="/svava-icon.png" alt="" />
        <h1>Svava Meet</h1>
        <p className="muted">Mötesassistent som spelar in, transkriberar och sammanfattar dina möten.</p>
        <label>
          E-post
          <input type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <label>
          Lösenord
          <input
            type="password"
            autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
            required
            minLength={mode === 'register' ? 10 : undefined}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        {error && <div className="alert error">{error}</div>}
        <button className="btn primary" disabled={busy}>
          {mode === 'login' ? 'Logga in' : 'Skapa konto'}
        </button>
        {allowRegistration && (
          <button type="button" className="btn link" onClick={() => setMode(mode === 'login' ? 'register' : 'login')}>
            {mode === 'login' ? 'Skapa nytt konto' : 'Jag har redan ett konto'}
          </button>
        )}
      </form>
    </div>
  );
}
